"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var VIEW_MODE = {
  SITE: 'SITE',
  EDIT: 'EDIT',
  PREVIEW: 'PREVIEW',
  SEO: 'SEO'
};
var _default = VIEW_MODE;
exports["default"] = _default;